import { createFileRoute } from "@tanstack/react-router";

import { HStack, VStack } from "@/components/Layout";
import CommutingInformationSection from "@/routes/_staff/person/-components/PersonProfileSection/employee-information/CommutingInformationSection";
import EmployeePaymentMethodSection from "@/routes/_staff/person/-components/PersonProfileSection/employee-information/EmployeePaymentMethodSection";
import SocialInsuranceJapanSection from "@/routes/_staff/person/-components/PersonProfileSection/employee-information/SocialInsuranceJapanSection";
import IncomeTaxInfoSection from "@/routes/_staff/person/-components/PersonProfileSection/employee-information/TaxJapanSection/IncomeTaxInfoSection";
import ResidentTaxInfoSection from "@/routes/_staff/person/-components/PersonProfileSection/employee-information/TaxJapanSection/ResidentTaxInfoSection";

import EmployeeInformationNavigation from "../../../../-components/PersonProfileNavigation/EmployeeInformationNavigation";
import EmployeeAssignmentSection from "../../../../-components/PersonProfileSection/employee-information/EmployeeAssignmentSection";
import EmployeeContactSection from "../../../../-components/PersonProfileSection/employee-information/EmployeeContactSection";
import EmployeeIdAndContractSection from "../../../../-components/PersonProfileSection/employee-information/EmployeeContractSection";
import WorkProfileSection from "../../../../-components/PersonProfileSection/employee-information/WorkProfileSection";

export const Route = createFileRoute(
  "/_staff/person/alumni/$id/_profile/employee-information/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HStack className="h-full">
      <nav className="sticky top-0 h-fit w-60 p-8">
        <EmployeeInformationNavigation />
      </nav>
      <div className="flex-1 overflow-y-auto p-8">
        <VStack className="w-full gap-4">
          <EmployeeIdAndContractSection />
          <EmployeeContactSection />
          <EmployeeAssignmentSection />
          <WorkProfileSection />
          <SocialInsuranceJapanSection />
          <IncomeTaxInfoSection />
          <ResidentTaxInfoSection />
          <CommutingInformationSection />
          <EmployeePaymentMethodSection />
        </VStack>
      </div>
    </HStack>
  );
}
